import PoputListImoveis from "../PopupListIMoveis"

interface MainframeProps {
    children: React.ReactNode
}

export default function Mainframe(props: MainframeProps) {
    
    return (
        <div style={{overflow: 'hidden'}}>
            <main>
                {props.children}
            </main>
            <PoputListImoveis />
        </div>
    )
}